import { Outlet } from "react-router-dom";
import { DocsNav } from "./DocsNav";

export function DocsLayout() {
  return (
    <div className="p-6 flex gap-6 max-w-6xl">
      <DocsNav />
      <div className="flex-1 min-w-0">
        <Outlet />
      </div>
    </div>
  );
}
